import { defineNuxtPlugin } from '#app'
import { createPinia } from 'pinia'
import piniaPersistedstate from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = createPinia()

  // Only use persistedstate plugin on client side
  if (import.meta.client) {
    pinia.use(piniaPersistedstate)
  }

  nuxtApp.vueApp.use(pinia)
  nuxtApp.provide('pinia', pinia)
})
